import { apiConfig } from '@yandex-int/k-common/client/api/config';
import { History } from 'history';
import last from 'lodash/last';
import { showIntlMessageNotification } from 'platform-components';
import { GRAVITIES, NOTIFICATION_THEMES } from 'platform-components/constants';
import { getExactPathMatch } from 'platform-components/utils';
import { IntlShape } from 'react-intl';
import { generatePath } from 'react-router';
import { Dispatch } from 'redux';

import { getPathName } from 'common.components/pathname/selectors';
import { getClassesWithCurrentSubject } from 'store/teacher-courses/selectors';
import { getTrimmedName } from 'utils/get-trimmed-name';
import { getSubjectFromPath } from 'utils/path';

import { MAX_CLASS_NAME_LENGTH, NOTIFICATION_TOAST_CLOSE_DELAY } from '../constants';

export function showLessonCopiedToClassesToast(args: {
    teamIds: Array<number>;
    cLessonIds: Array<number>;
    intl: IntlShape;
    history: History;
}) {
    const { cLessonIds, teamIds, intl, history } = args;

    return function (dispatch: Dispatch<any>, getState: () => any) {
        const subject = getSubjectFromPath();

        const teams = getClassesWithCurrentSubject(getState(), { subject });
        const targetTeams = teams
            .filter(({ id }) => teamIds.includes(id))
            .map(({ name, level }) =>
                intl.formatMessage(
                    { id: 'lesson.toast.lessonCopiedToClasses.className' },
                    { level, className: getTrimmedName(name, MAX_CLASS_NAME_LENGTH) }
                )
            );

        const commonNotificationProps = {
            closeDelay: NOTIFICATION_TOAST_CLOSE_DELAY,
            gravity: GRAVITIES.BOTTOM,
            messageId: 'lesson.toast.lessonCopiedToClasses',
            theme: NOTIFICATION_THEMES.TOAST,
        };

        if (targetTeams.length > 1) {
            dispatch(
                showIntlMessageNotification({
                    ...commonNotificationProps,
                    messageValues: {
                        classes: intl.formatMessage(
                            { id: 'lesson.toast.lessonCopiedToClasses.classes' },
                            {
                                first: targetTeams.slice(0, -1).join(', '),
                                last: last(targetTeams),
                            }
                        ),
                        count: targetTeams.length,
                    },
                })
            );
        } else {
            dispatch(
                showIntlMessageNotification({
                    ...commonNotificationProps,
                    messageValues: {
                        class: targetTeams[0],
                        count: 1,
                    },
                    notificationAction: () => {
                        const url = getRedirectUrl(cLessonIds[0], teamIds[0]);
                        if (url) {
                            history.push(url);
                        }
                    },
                    notificationMessageId: 'lesson.toast.lessonCopiedToClasses.show',
                })
            );
        }
    };
}

function getRedirectUrl(cLessonId: number, teamId: number) {
    const pathname = getPathName();
    if (!pathname) {
        return null;
    }

    const urls = apiConfig.getStaticUrls();
    const match = getExactPathMatch(urls, pathname);
    const params = match?.params || {};

    return `${generatePath(urls.labSubjectLessonsDrafts, { ...params, classId: teamId })}?lessonId=${cLessonId}`;
}
